module.exports = __webpack_public_path__ + "static/media/red-green-D.6c2d36a2.svg";